// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const XmarkFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="XmarkFilledIcon" ref={forwardedRef} {...props}>
      <path d="m10.022 12.106 4.886 4.85 2.217-2.01L12.143 10l4.982-4.945-2.217-2.011-4.886 4.85L5.092 3 2.875 5.01 7.901 10l-5.026 4.99L5.092 17z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const XmarkFilledIcon = /* @__PURE__ */ Object.assign(
  XmarkFilledIconComponent,
  { displayName: 'XmarkFilledIcon' },
);
